import type { RecommendationContext } from "@memorang/types";
import type { ContextRecommendationResult } from "../contract/recommendation-context-types";
import type { RecommendationResult } from "../types";

export const adaptContextResultForThreeAxisUi = ({
	context,
	result,
}: {
	context: RecommendationContext;
	result: ContextRecommendationResult;
}): RecommendationResult => {
	if (result.status !== "READY") {
		return {
			status: "UNAVAILABLE",
			examId: result.examId,
			reason:
				result.reason === "NO_MATCHING_CELLS"
					? "NO_MATCHING_CELLS"
					: "NO_AVAILABLE_ITEMS",
			sessions: [],
		};
	}
	const trackAxes = context.axes.filter(({ role }) => role === "TRACK");
	const progressionAxes = context.axes.filter(
		({ role }) => role === "PROGRESSION",
	);
	const dimensionAxes = context.axes.filter(({ role }) => role === "DIMENSION");
	if (
		trackAxes.length !== 1 ||
		progressionAxes.length !== 1 ||
		dimensionAxes.length !== 1
	) {
		throw new Error(
			"UI adapter requires one track, progression, and dimension axis",
		);
	}
	return {
		status: "READY",
		examId: result.examId,
		sessions: result.sessions.map((session) => ({
			rank: session.rank,
			cellId: session.cellId,
			mode: session.mode,
			reason: session.reason,
			tagIds: {
				skill: session.coordinates[trackAxes[0].id],
				proficiency: session.coordinates[progressionAxes[0].id],
				questionType: session.coordinates[dimensionAxes[0].id],
			},
			...(session.requestedDurationMinutes
				? { requestedDurationMinutes: session.requestedDurationMinutes }
				: {}),
			requestedItemCount: session.requestedItemCount,
			actualItemCount: session.actualItemCount,
			isPartial: session.isPartial,
			secondsPerItemEstimate: session.secondsPerItemEstimate,
			estimatedDurationSeconds: session.estimatedDurationSeconds,
			timeEstimateBasis: "FIXED_FALLBACK",
			observedMastery: session.observedMastery,
			effectiveMastery: {
				...session.effectiveMastery,
				inferredFromProficiencyId:
					session.effectiveMastery.inferredFrom?.valueId ?? null,
			},
			quickStudyMeta: session.quickStudyMeta,
		})),
	};
};
